<template>
	<div>
		<div class="modal_flex">
			<div class="item_box" style="font-size: 18px;font-weight: bold;">
				<div class="title_box">签约管理</div>
			</div>
			<div class="item_box" style="color: #277dd3;"> <Button type="primary">查看客户备注</Button></div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>客户经理：</div>
				<Input v-model="formItem.manager" disabled style="width: 250px;"></Input>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>部门：</div>
				<Input v-model="formItem.department" disabled style="width: 250px;"></Input>
			</div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>客户姓名：</div>
				<Input v-model="formItem.client_name" disabled style="width: 250px;color: #277dd3;"></Input>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>协助人：</div>
				<Input v-model="formItem.help_name" disabled style="width: 250px;"></Input>
			</div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>合同号：</div>
				<Input v-model="formItem.contract_number" :disabled="formItem.status ==2" style="width: 250px;"></Input>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>费率：</div>
				<Input v-model="formItem.rate" :disabled="formItem.status ==2" style="width: 250px;">
				<span slot="append">%</span>
				</Input>
			</div>
		</div>
		<!--div class="modal_flex" v-if="formItem.sincerity_id != 0">
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金：</div>
                <Input v-model="formItem.sincerity_money" disabled style="width: 250px;">
                    <span slot="append">元</span>
                </Input>
            </div>
            <div class="item_box">
                <Button class="btn" @click="uploadModal = true" type="primary" v-if="formItem.sincerity_deal_status == 0">上传凭证退款</Button>
                <Button class="btn" @click="applySincerityIncome" type="primary" v-if="formItem.sincerity_deal_status == 0">申请转创收</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == -1">已申请退款</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == 1">已确认退款</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == -2">已申请转为创收</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == 2">已确认转为创收</Button>
                <span>诚意金状态：{{formItem.sincerity_status_name}}</span>
            </div>
        </div-->
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金收款方式：</div>
				<Select v-model="formItem.sincerity_type" :disabled="formItem.status ==2" style="width:250px">
					<Option v-for="item in sincerity_type_list" :value="item.value" :key="item.value">{{
                        item.label }}
					</Option>
				</Select>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金：</div>
				<Input v-model="formItem.sincerity_money" :disabled="formItem.status ==2" style="width: 250px;">
				</Input>
			</div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>是否拓客：</div>
				<template>
					<i-switch :disabled="formItem.status ==2" v-model="formItem.is_introduce" />
				</template>
			</div>
		</div>
		<div class="modal_flex" v-if="formItem.is_introduce === true">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>拓客姓名：</div>
				<Input v-model="formItem.introduce_name" :disabled="formItem.status ==2" style="width: 250px;">
				</Input>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>拓客电话：</div>
				<Input v-model="formItem.introduce_mobile" :disabled="formItem.status ==2" style="width: 250px;">
				</Input>
			</div>
		</div>
		<div class="modal_flex">
			<div style="width: 130px; text-align: right;">新增合同备注：</div>
			<Input v-model="formItem.remark" disabled style="width: 700px;" type="textarea" :rows="4" />
		</div>
		<div class="modal_flex">
			<div style="width: 130px; text-align: right;">添加合同：</div>
			<MyUpload :onlyRead="formItem.status ==2" :edit="true" ref="upload"></MyUpload>
		</div>
		<div class="modal_flex">
			<div style="width: 130px; text-align: right;">添加视频：</div>
			<div class="demo-upload-list" v-for="(item,index) in videoList" :key="index">
				<template v-if="item.status === 'finished'">
					<!--img :src="{item.url"}-->
					<span>{{item.name}}</span>
					<div class="demo-upload-list-cover">
						<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
						<!--Icon type="ios-trash-outline"  @click.native="handleRemove(item)"></Icon-->
					</div>
				</template>
				<template v-else>
			  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
				</template>
			</div>
			<Upload multiple ref="videoUpload" :on-success="handleSuccess" :action="actionUrl">
				<Button icon="ios-cloud-upload-outline">上传视频</Button>
			</Upload>
		</div>
		<modal :title="videoName" v-model="visible" fullscreen>
			<video :src="previewPath" v-if="visible" controls="controls" width="100%"></video>
		</modal>
	</div>
</template>

<script>
	import config from "../../config";
	import addFile from '../tool/addFile.vue';
	import MyUpload from '../tool/Upload.vue'
	import {
		getContract,
		applySincerityRefund,
		applySincerityIncome,
		editContract
	} from '@/api/task'
	import {
		mapActions,
		mapGetters
	} from "vuex";

	export default {
		name: "EditContract",
		components: {
			MyUpload,
			addFile
		},
		props: ['contractId'],
		mounted() {
			this.actionUrl = 'https://zycloud.gzjzg8.com/app/api/uploadFile';
			this.videoList = this.$refs.videoUpload.fileList;
			this.loadData();
		},
		computed: {
			...mapGetters(['token']),
		},
		watch: {
			contractId() {
				this.loadData();
			}
		},
		data() {
			return {
				uploadModal: false,
				actionUrl: '',
				visible: false,
				previewPath: '',
				videoName: '',
				videoList: [],
				videoFileUrl: '',
				formItem: {
					manager: '',
					department: '',
					client_name: '',
					phone: '',
					contract_number: '',
					rate: '',
					sincerity_money: '',
					sincerity_type: '',
					remark: '',
					status_name: '',
					sincerity_status_name: '',
					is_introduce: false,
					introduce_name: '',
					introduce_mobile: '',
				},
				sincerity_type_list: [{
					value: 1,
					label: '支付宝',
				}, {
					value: 2,
					label: '微信支付',
				}, {
					value: 3,
					label: '现金支付',
				}, {
					value: 4,
					label: '银行卡支付',
				}, ],
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			async loadData() {
				let that = this;
				if (that.contractId != 0) {
					let res = await getContract(that, {
						token: that.token,
						id: that.contractId
					});
					if (res.code = 1) {
						that.formItem = res.data.item;
						console.log(res.data.item.ext_info.imgList)
						that.$refs['upload'].uploadList = res.data.item.ext_info.imgList;
						this.videoList = res.data.item.ext_info.videoList;
						that.modal = true;
					}
				}
			},
			save() {
				let that = this;
				let data = {
					token: that.token,
					data: that.formItem,
					client_id: that.clientId
				};
				if (data.data.status == 2) {
					that.$emit('reloadData');
					return;
				}
				data.data.imgList = that.$refs['upload'].uploadList;
				data.data.videoList = this.$refs.videoUpload.fileList;
				data.data.status = 1; //将状态改为审核中
				this.$Modal.confirm({
					title: "提交将会将合同给财务审核诚意金等情况",
					onOk: async () => {
						let res = await editContract(that, data);
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.$emit('reloadData');
						}
					}
				})
			},
			//预览视频
			handleView(path, name) {
				this.videoName = name;
				this.previewPath = path;
				this.visible = true;
			},
			//删除视频
			handleRemove(file) {
				const videoList = this.$refs.videoUpload.fileList;
				this.$refs.videoUpload.fileList.splice(fileList.indexOf(file), 1);
			},
			//视频上传成功
			handleSuccess(res, file) {
				file.url = res.data.url
				this.videoList = this.$refs.videoUpload.fileList;
			},
			fileOk() {
				var that = this;
				let fileUrl = that.$refs['addFile'].fileUrl;
				this.throttle(async function() {
					let res = await applySincerityRefund(that, {
						token: that.token,
						id: that.formItem.sincerity_id,
						file: fileUrl
					});
					if (res.code = 1) {
						that.loadData();
						that.uploadModal = false;
					}
				}, 500)
			},
			applySincerityIncome() {
				let that = this;
				this.$Modal.confirm({
					title: '确认申请转为创收吗？',
					onOk: async () => {
						let res = await applySincerityIncome(that, {
							token: that.token,
							id: that.formItem.sincerity_id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.icon-bixuan {
		color: red;
	}

	.title_css {
		width: 86px;
		text-align: right;
		margin-right: 10px;
	}

	.list_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.modal_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;

		.item_box {
			width: 50%;
			display: flex;
			align-items: center;

			.btn {
				margin: 0 10px;
			}

			.title_box {
				width: 130px;
				text-align: right;
			}
		}

		.icon-bixuan {
			color: #FE485B;
		}
	}

	.demo-upload-list {
		display: inline-block;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
